import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResultsMobileComponent } from './results-mobile.component';

const routes: Routes = [
  {
    path: '',
    component: ResultsMobileComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResultsMobileRoutingModule {}
